import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Row,
  Spin,
  message,
  App,
  Modal,
  Checkbox,
  Tag,
  Upload
} from "antd";
import { LeftOutlined, LoadingOutlined, PlusOutlined, Loading3QuartersOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { ADD_AZURE_CONFIG, COURSE_LIST, LIST_PACKAGE } from "../../../apis/apis";
import { useNavigate } from "react-router-dom";
import CulsightPageLoader from "../../../components/CulsightPageLoader";
import HtmlEditorWithPreview from "../../../components/HtmlEditorWithPreview";

function AddMicrosoft() {
  const { notification } = App.useApp();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [courseLoading, setCourseLoading] = useState(false);

  const [tenant_id, set_tenant_id] = useState("");
  const [client_id, set_client_id] = useState("");
  const [client_secret, set_client_secret] = useState("");
  const [domain, set_domain] = useState("");
  const [login_url, set_login_url] = useState("");

  const [certificate_html, set_certificate_html] = useState("");


  // PACKAGE STATES
  const [allow_package, set_allow_package] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [packageLoading, setPackageLoading] = useState(false);

  const [packageModal, setPackageModal] = useState(false);
  const [tempSelectedPackages, setTempSelectedPackages] = useState([]);
  const [packageSearchText, setPackageSearchText] = useState("");



  // Certificate Upload States
  const [certificateFile, setCertificateFile] = useState("");
  const [certificatePreview, setCertificatePreview] = useState("");
  const [certificateLoading, setCertificateLoading] = useState(false);
  const [certificateError, setCertificateError] = useState("");


  const getBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.onload = () => cb(reader.result);
    reader.readAsDataURL(file);
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none", }} type="button">
      {certificateLoading ? (
        <Loading3QuartersOutlined />
      ) : (
        <PlusOutlined />
      )}
      <div style={{ marginTop: 8, }}>Upload</div>
    </button>
  );


  // OBJECT FORMAT [{id,title}]
  const [allow_course, set_allow_course] = useState([]);

  const [courseList, setCourseList] = useState([]);
  const [errors, set_errors] = useState("");

  const [courseModal, setCourseModal] = useState(false);
  const [tempSelectedCourses, setTempSelectedCourses] = useState([]);
  const [searchText, setSearchText] = useState("");

  /* ---------------- Page Loader ---------------- */
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 300);
    return () => clearTimeout(timer);
  }, []);

  /* ---------------- FETCH COURSES ---------------- */
  const fetchCourses = async (title = "") => {
    setCourseLoading(true);
    try {
      const formData = new FormData();
      if (title) formData.append("title", title);

      const res = await COURSE_LIST(formData);

      if (res?.data?.status) {
        setCourseList(res.data.data);
      } else setCourseList([]);
    } catch {
      setCourseList([]);
    } finally {
      setCourseLoading(false);
    }
  };




  const fetchPackages = async (title = "") => {
    setPackageLoading(true);
    try {
      const formData = new FormData();
      if (title) formData.append("name", title);

      const res = await LIST_PACKAGE(formData);
      if (res?.data?.status) {
        setPackageList(res.data.data);
      } else {
        setPackageList([]);
      }
    } catch {
      setPackageList([]);
    } finally {
      setPackageLoading(false);
    }
  };


  /* ---------------- SUBMIT ---------------- */
  const onFinish = async () => {
    setLoading(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("tenant_id", tenant_id);
    FORM_DATA.append("client_id", client_id);
    FORM_DATA.append("client_secret", client_secret);
    FORM_DATA.append("domain", domain);
    FORM_DATA.append("login_url", login_url);
    FORM_DATA.append("certificate", certificateFile);
    FORM_DATA.append("certificate_html", certificate_html);
    FORM_DATA.append("allow_course", JSON.stringify(allow_course.map((c) => c.id)));
    FORM_DATA.append("allow_package", JSON.stringify(allow_package.map((p) => p.id)));


    try {
      const response = await ADD_AZURE_CONFIG(FORM_DATA);

      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });
        navigate("/microsoft");
      } else {
        set_errors(response?.data?.errors);
        setLoading(false);
      }
    } catch (error) {
      message.error(
        "Server Error: " +
        (error?.response?.data?.message || "Unknown error")
      );
      setLoading(false);
    }
  };

  /* ---------------- MODAL LOGIC ---------------- */
  const openCourseModal = () => {
    setTempSelectedCourses(allow_course);
    setCourseModal(true);
    fetchCourses();
  };

  const toggleCourse = (course) => {
    setTempSelectedCourses((prev) =>
      prev.find((c) => c.id === course.id)
        ? prev.filter((c) => c.id !== course.id)
        : [...prev, { id: course.id, title: course.title }]
    );
  };

  const saveCourses = () => {
    set_allow_course(tempSelectedCourses);
    setCourseModal(false);
  };
  /* ---------------- MODAL LOGIC ---------------- */
  const openPackageModal = () => {
    setTempSelectedPackages(allow_package);
    setPackageModal(true);
    fetchPackages();
  };

  const togglePackage = (pkg) => {
    setTempSelectedPackages((prev) =>
      prev.find((p) => p.id === pkg.id)
        ? prev.filter((p) => p.id !== pkg.id)
        : [...prev, { id: pkg.id, name: pkg.name }]
    );
  };

  const savePackages = () => {
    set_allow_package(tempSelectedPackages);
    setPackageModal(false);
  };

  return (
    <div className="lms-body">
      <Card>
        <div className="lms-form">
          <Row>
            <Col span={12}>
              <h2>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/microsoft")}
                >
                  <LeftOutlined />
                </span>{" "}
                Add Microsoft
              </h2>
            </Col>
          </Row>

          {loading ? (
            <CulsightPageLoader />
          ) : (
            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item label="Tenant ID">
                <Input value={tenant_id} onChange={(e) => set_tenant_id(e.target.value)} />
                {errors?.tenant_id && (
                  <span style={{ color: "red" }}>{errors.tenant_id}</span>
                )}
              </Form.Item>

              <Form.Item label="Client ID">
                <Input value={client_id} onChange={(e) => set_client_id(e.target.value)} />
                {errors?.client_id && (
                  <span style={{ color: "red" }}>{errors.client_id}</span>
                )}
              </Form.Item>

              <Form.Item label="Client Secret">
                <Input value={client_secret} onChange={(e) => set_client_secret(e.target.value)} />
                {errors?.client_secret && (
                  <span style={{ color: "red" }}>{errors.client_secret}</span>
                )}
              </Form.Item>

              <Form.Item label="Domain">
                <Input onChange={(e) => set_domain(e.target.value)} />
                {errors?.domain && (
                  <span style={{ color: "red" }}>{errors.domain}</span>
                )}
              </Form.Item>

              <Form.Item label="Login Url">
                <Input onChange={(e) => set_login_url(e.target.value)} />
                {errors?.login_url && (
                  <span style={{ color: "red" }}>{errors.login_url}</span>
                )}
              </Form.Item>

              {/* ⭐ TAG SELECTOR UI */}
              <Form.Item label="Allow Course">
                <div
                  onClick={openCourseModal}
                  style={{
                    minHeight: 44,
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    padding: "6px 8px",
                    cursor: "pointer",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 6,
                    alignItems: "center",
                  }}
                >
                  {allow_course.length === 0 && (
                    <span style={{ color: "#999" }}>Select Courses</span>
                  )}

                  {allow_course.map((course) => (
                    <Tag
                      key={course.id}
                      closable
                      onClose={(e) => {
                        e.preventDefault();
                        set_allow_course((prev) =>
                          prev.filter((c) => c.id !== course.id)
                        );
                      }}
                      style={{ marginBottom: 4 }}
                    >
                      {course.title}
                    </Tag>
                  ))}
                  {errors?.allow_course && (
                    <span style={{ color: "red" }}>{errors.allow_course}</span>
                  )}
                </div>
              </Form.Item>

              <Form.Item label="Allow Package">
                <div
                  onClick={openPackageModal}
                  style={{
                    minHeight: 44,
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    padding: "6px 8px",
                    cursor: "pointer",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 6,
                    alignItems: "center",
                  }}
                >
                  {allow_package.length === 0 && (
                    <span style={{ color: "#999" }}>Select Packages</span>
                  )}

                  {allow_package.map((pkg) => (
                    <Tag
                      key={pkg.id}
                      closable
                      onClose={(e) => {
                        e.preventDefault();
                        set_allow_package((prev) =>
                          prev.filter((p) => p.id !== pkg.id)
                        );
                      }}
                      style={{ marginBottom: 4 }}
                    >
                      {pkg.name}
                    </Tag>
                  ))}

                  {errors?.allow_package && (
                    <span style={{ color: "red" }}>{errors.allow_package}</span>
                  )}
                </div>
              </Form.Item>

              <Form.Item label="Upload Certificate">
                <Upload
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => {
                    setCertificateLoading(true);

                    const isValidType =
                      file.type === "image/jpeg" ||
                      file.type === "image/png" ||
                      file.type === "image/jpg";

                    const isValidSize = file.size <= 2 * 1024 * 1024; // 2MB

                    if (!isValidType) {
                      setCertificateError("Only JPG / PNG files allowed");
                      setCertificateLoading(false);
                      return false;
                    }

                    if (!isValidSize) {
                      setCertificateError("Certificate must be ≤ 2MB");
                      setCertificateLoading(false);
                      return false;
                    }

                    const img = new Image();
                    img.src = URL.createObjectURL(file);

                    img.onload = () => {
                      if (img.width === 1000 && img.height === 692) {
                        setCertificateError("");
                        setCertificateFile(file);
                        getBase64(file, (url) => setCertificatePreview(url));
                      } else {
                        setCertificateError(
                          "Certificate size must be exactly 1000 x 692 pixels"
                        );
                        setCertificateFile("");
                        setCertificatePreview("");
                      }
                      setCertificateLoading(false);
                    };


                    return false;
                  }}
                >
                  {certificatePreview ? (
                    <img
                      src={certificatePreview}
                      alt="certificate"
                      style={{ width: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>

                {certificateError && (
                  <span style={{ color: "red", display: "block", marginTop: 6 }}>
                    {certificateError}
                  </span>
                )}

                <p style={{ color: "#65e7c4", marginTop: "10px" }}>
                  Note - Certificate must be smaller than or equal to 2MB and must be exactly 1000 x 692 pixels.

                </p>
              </Form.Item>

              <HtmlEditorWithPreview
                setHtmlCode={set_certificate_html}
                description="Message"
                htmlCode={certificate_html}
              />

              <Form.Item>
                <Button type="primary" htmlType="submit" style={{ float: "right" }}>
                  {loading ? (
                    <Spin indicator={<LoadingOutlined spin />} size="small" />
                  ) : (
                    "Save"
                  )}
                </Button>
              </Form.Item>


            </Form>
          )}
        </div>
      </Card>

      {/*  COURSE MODAL */}
      <Modal
        title="Select Courses"
        open={courseModal}
        onCancel={() => setCourseModal(false)}
        onOk={saveCourses}
        width={700}
      >
        <Input
          placeholder="Search course..."
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            fetchCourses(e.target.value);
          }}
          style={{ marginBottom: 15 }}
        />

        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          {courseLoading ? (
            <CulsightPageLoader />
          ) : (
            courseList.map((course) => (
              <div key={course.id} style={{ padding: "6px 0" }}>
                <Checkbox
                  checked={tempSelectedCourses.some((c) => c.id === course.id)}
                  onChange={() => toggleCourse(course)}
                >
                  {course.title}
                </Checkbox>
              </div>
            ))
          )}
        </div>
      </Modal>

      {/*  package MODAL */}

      <Modal
        title="Select Packages"
        open={packageModal}
        onCancel={() => setPackageModal(false)}
        onOk={savePackages}
        width={700}
      >
        <Input
          placeholder="Search package..."
          value={packageSearchText}
          onChange={(e) => {
            setPackageSearchText(e.target.value);
            fetchPackages(e.target.value);
          }}
          style={{ marginBottom: 15 }}
        />

        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          {packageLoading ? (
            <CulsightPageLoader />
          ) : (
            packageList.map((pkg) => (
              <div key={pkg.id} style={{ padding: "6px 0" }}>
                <Checkbox
                  checked={tempSelectedPackages.some(
                    (p) => p.id === pkg.id
                  )}
                  onChange={() => togglePackage(pkg)}
                >
                  {pkg.name}
                </Checkbox>
              </div>
            ))
          )}
        </div>
      </Modal>
    </div>
  );
}

export default AddMicrosoft;
